import { Table } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { PAYMENTS_ACCOUNTS_HEADER, PREFIX, U_KEY } from '@app/constants';

import { usePaymentAccounts } from '@pages/Finances/PaymentAccountsList/hooks/usePaymentAccounts';

import { adaptDataToTable } from '@pages/Finances/PaymentAccountsList/utils/adaptDataToTable';

import type { FC } from 'react';

import '@pages/Finances/PaymentAccountsList/styles/PaymentAccountsList.mobile.scss';
import '@pages/Finances/PaymentAccountsList/styles/PaymentsAccountList.desktop.scss';

export const PaymentAccounts: FC = () => {
  const {
    isLoading,
    paymentAccounts,
    handleEdit,
    isMobile,
    hasUserRightToEditPaymentsAccount,
    hasUserRightForModuleView,
    handleChange,
    pageNumber,
    rowsPerPage,
  } = usePaymentAccounts();

  if (!hasUserRightForModuleView) {
    return <Error403Unauthorized />;
  }

  return (
    <div className={`${PREFIX}payment-accounts`}>
      <Table
        rowKey={(record) => record[U_KEY]}
        loading={isLoading}
        columns={PAYMENTS_ACCOUNTS_HEADER}
        className="payment-accounts-table"
        dataSource={adaptDataToTable(
          paymentAccounts,
          handleEdit,
          hasUserRightToEditPaymentsAccount
        )}
        rowClassName={(row) =>
          row.isDeleted
            ? 'archived-payment-account-item'
            : 'payment-account-item'
        }
        pagination={{
          size: isMobile ? 'small' : 'default',
          showSizeChanger: true,
          position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
          showTotal: (total, range) =>
            `Показаны ${range[0]}-${range[1]} из ${total}`,
          pageSize: rowsPerPage,
          current: pageNumber,
          onChange: handleChange,
        }}
      />
    </div>
  );
};
